(function () {
  'use strict';

  function init(root) {
    if (root.dataset.guideReady === 'true') return;
    root.dataset.guideReady = 'true';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-guide-card]'));
    if (!cards.length) return;
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-filter-group]'));
    var count = root.querySelector('[data-guide-count]');
    var empty = root.querySelector('[data-guide-empty]');
    var reset = root.querySelector('[data-guide-reset]');
    var state = {};

    groups.forEach(function (group) {
      var key = group.dataset.filterGroup;
      state[key] = 'all';
      group.querySelectorAll('[data-filter-value]').forEach(function (button) {
        button.addEventListener('click', function () {
          state[key] = button.dataset.filterValue;
          group.querySelectorAll('[data-filter-value]').forEach(function (peer) {
            var active = peer === button;
            peer.classList.toggle('is-active', active);
            peer.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          apply();
        });
      });
    });

    function priceMatches(card, value) {
      if (!value || value === 'all') return true;
      var cents = Number(card.dataset.price || 0);
      if (value === 'under-500') return cents < 50000;
      if (value === '500-1000') return cents >= 50000 && cents < 100000;
      return cents >= 100000;
    }

    function apply() {
      var visible = 0;
      cards.forEach(function (card) {
        var matches = true;
        Object.keys(state).forEach(function (key) {
          var value = state[key];
          if (key === 'budget') matches = matches && priceMatches(card, value);
          else if (value !== 'all') matches = matches && card.dataset[key] === value;
        });
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (count) count.textContent = visible + (root.dataset.guideMode === 'recommendations' ? ' recommendations shown' : ' chairs shown');
      if (empty) empty.hidden = visible !== 0;
    }

    if (reset) reset.addEventListener('click', function () {
      groups.forEach(function (group) {
        var first = group.querySelector('[data-filter-value="all"]');
        if (first) first.click();
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-chair-guide]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
